import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useEcommerceContext } from '@blaze-cms/ecommerce-context';
import { GET_CURRENCIES_QUERY } from '../../services';
import { CONTEXT_KEYS } from '../constants';
import { CURRENCY_CLASSNAME } from './constants';
import { addModifier } from '../helpers';
import CurrencySelect from './CurrencySelect';

// TODO: check how frontend will know which currency symbol to render
const Currency = ({ modifier }) => {
  const { currencyKey } = CONTEXT_KEYS;
  const { [currencyKey]: currency, updateCurrency } = useEcommerceContext();
  const { data: { currencies } = {} } = useQuery(GET_CURRENCIES_QUERY);

  const handleOnChange = ({ target: { value } }) => {
    updateCurrency(value);
  };

  if (!currencies || !currencies.length) return null;
  const classNameWithModifier = addModifier(CURRENCY_CLASSNAME, modifier);

  return (
    <div className={classNameWithModifier}>
      <CurrencySelect currency={currency} currencies={currencies} handleOnChange={handleOnChange} />
    </div>
  );
};

Currency.propTypes = { modifier: PropTypes.string };

Currency.defaultProps = { modifier: '' };

export default Currency;
